import { AuthenticatedApiClient, JwtAuthenticatedApiClient } from '@guiker/lease-shared'
import { useAuthenticatedApiClient, useJwtAuthenticatedApiClient } from '@guiker/react-framework'

const useLeaseApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)

const useLeaseJwtAuthenticatedApiClient = useJwtAuthenticatedApiClient(JwtAuthenticatedApiClient)

export { useLeaseApiClient, useLeaseJwtAuthenticatedApiClient }
